import React from 'react';
import { Link } from 'react-router-dom';
export default function StudioBrand({ to = '/dashboard' }) {
  return <Link to={to} className="studio-brand" aria-label="Adfini home"><img src="/media/homepage/images/Adfini_horizontal_logo.png" alt="Adfini" width="2172" height="724" /></Link>;
}
